import { MDBTooltip } from "mdb-react-ui-kit";
import React, { useEffect, useState } from "react";
import { useSelectFunctions, useSpecialFunctions } from "../../functions";
import ErrorCodes from "../../constants/ErrorCodes";

const MyPackagesModal = ({
  show,
  onClose,
  setHasUpgrade,
  data,
  setSessionNoLongerExists,
  systemPreferences,
  setSystemPreferences,
}) => {
  const [showWarning, setShowWarning] = useState(false);

  const { getSystemPreferencesRacing } = useSelectFunctions();
  const { getUTCDateInfo, isExpiringSoon, getExpireText } =
    useSpecialFunctions();

  useEffect(() => {
    if (!show) return;

    const fetchData = async () => {
      try {
        setHasUpgrade(false);

        const res = await getSystemPreferencesRacing(data.Session);

        if (res?.error) {
          if (
            res.Result === ErrorCodes.InvalidSession ||
            res.Result === ErrorCodes.SessionNoLongerExists
          ) {
            setSessionNoLongerExists(true);
          }
          return;
        }

        const packages = res.TrackPackages || [];
        setSystemPreferences((prev) => ({
          ...prev,
          TrackPackages: packages,
        }));

        const hasExpiring = packages.some((pkg) =>
          isExpiringSoon(pkg.Expiration),
        );

        const today = new Date().toDateString();
        const closedDate = localStorage.getItem("packagesWarningClosedDate");

        if (hasExpiring && closedDate !== today) {
          setShowWarning(true);
        } else {
          setShowWarning(false);
        }
      } catch (error) {
        console.error("Error fetching preferences:", error);
      }
    };

    fetchData();
  }, [show]);

  return (
    <>
      {show && <div className="modal-backdrop fade show"></div>}
      <div
        className={`modal fade ${show ? "show d-block" : ""}`}
        aria-labelledby="myPackagesModal"
        aria-hidden={!show}
      >
        <div className="modal-dialog modal-dialog-centered modal-md">
          <div className="modal-content">
            <div className="modal-header dialog-modal">
              <h5
                className="modal-title"
                id="myPackagesModal"
                style={{ color: "#99ddff" }}
              >
                Packages Upgrade
              </h5>
            </div>

            <div className="modal-body">
              {showWarning && (
                <div className="expiring-alert">
                  <span>⚠️ Some packages are about to expire</span>
                  <button
                    className="close-alert"
                    onClick={() => {
                      setShowWarning(false);
                      localStorage.setItem(
                        "packagesWarningClosedDate",
                        new Date().toDateString(),
                      );
                    }}
                  >
                    ✕
                  </button>
                </div>
              )}
              <div
                className="divTablePackage"
                style={{
                  overflow: "auto",
                  border: "1px solid #ccc",
                  borderRadius: "5px",
                }}
              >
                <table className="table table-hover table-sm">
                  <thead
                    style={{
                      position: "sticky",
                      top: 0,
                      background: "#d9d9d9",
                      zIndex: 1001,
                    }}
                  >
                    <tr className="text-center">
                      <th className="p-2">Package</th>
                      <th className="p-2">Expiration</th>
                      <th className="p-2">Up</th>
                    </tr>
                  </thead>

                  <tbody>
                    {systemPreferences?.TrackPackages.map((row, i) => {
                      const expiring = isExpiringSoon(row.Expiration);
                      const isDisabled = row.Category === 1;

                      return (
                        <tr
                          key={i}
                          style={{
                            opacity: isDisabled ? 0.5 : 1,
                            cursor: "default",
                          }}
                        >
                          {/* Package */}
                          <td className="text-center">
                            {row.TrackPackageName}
                          </td>

                          {/* Expiration */}
                          <td
                            className="text-center"
                            style={{
                              pointerEvents:
                                isDisabled && !expiring ? "none" : "auto",
                            }}
                          >
                            {row.Expiration && expiring ? (
                              <MDBTooltip
                                tag="span"
                                title={getExpireText(row.Expiration)}
                              >
                                <span className="expiration-warning">
                                  <span className="blink">⚠️</span>
                                  {getUTCDateInfo(row.Expiration)}
                                </span>
                              </MDBTooltip>
                            ) : (
                              row.Expiration && getUTCDateInfo(row.Expiration)
                            )}
                          </td>

                          {/* Upgrade */}
                          <td
                            className="text-center"
                            style={{
                              pointerEvents: isDisabled ? "none" : "auto",
                            }}
                          >
                            {row.Category !== 1 && (
                              <MDBTooltip
                                tag="i"
                                wrapperProps={{ href: "#" }}
                                title="Upgrade"
                              >
                                <i
                                  className="fas fa-arrow-alt-circle-up"
                                  style={{
                                    color: "#009900",
                                    fontSize: "20px",
                                    cursor: "pointer",
                                  }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    window.open(
                                      window.config.SiteConfig
                                        .urlContactUpgrade,
                                      "_blank",
                                    );
                                  }}
                                  onMouseEnter={(e) => e.stopPropagation()}
                                />
                              </MDBTooltip>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
                onClick={onClose}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MyPackagesModal;
